export default __webpack_public_path__ + "static/media/CNo.90-5.b21387c4.jpg";